import { ModuleWithProviders, NgModule } from '@angular/core';

import { CultureService } from './culture.service';
import { ILocalizationOptions, LOCALIZATION_OPTIONS, defaultLocalizationOptions } from './localization-options';
import { ResourceService } from './resource.service';
import { ResourcePipe } from './resource.pipe';
import { ResourceDirective } from './resource.directive';
import { ResourceAsyncPipe } from './resource-async.pipe';
import { ResourceAgGridService } from './resource-ag-grid.service';

@NgModule({
	imports: [],
	exports: [ResourcePipe, ResourceDirective, ResourceAsyncPipe],
	declarations: [ResourcePipe, ResourceDirective, ResourceAsyncPipe],
})
export class LocalizationModule {
	static forRoot(options?: Partial<ILocalizationOptions>): ModuleWithProviders<LocalizationModule> {
		return {
			ngModule: LocalizationModule,
			providers: [
				{
					provide: LOCALIZATION_OPTIONS,
					useValue: Object.assign(defaultLocalizationOptions, options || {}),
				},
				CultureService,
				ResourceService,
				ResourceAgGridService,
			],
		};
	}
}
